import { mediaItems } from '@/mocks/homepage';

export default function Media() {
  return (
    <section id="media" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-8 md:mb-10">
          <i className="ri-play-list-2-line text-xl text-primary-500"></i>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading">
            精彩推荐
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 scale-75 group-hover:scale-100">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-[10px] rounded">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500/90 text-background-50 text-[10px] font-medium rounded">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 font-heading group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-eye-line text-sm"></i>
                    <span>{item.views}次观看</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}